import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Assembly, AssemblySaveRequest } from 'src/app/models/assembly.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssembliesService {
  private baseUrl = environment.landmark_API_URL + '/assemblies';

  selectedAssembly = signal<Assembly | null>(null);

  constructor(private http: HttpClient) {
  }

  setSelectedAssembly(assembly: Assembly) {
    console.log('setSelectedAssembly', assembly);
    this.selectedAssembly.set(assembly)
  }

  unselectAssembly() {
    this.selectedAssembly.set(null);
  }

  getSelectedAssembly() {
    return this.selectedAssembly();
  }

  getCatalog(fid: number,planId: number, ssid: number): Observable<Assembly[]> {
    return this.http.get<Assembly[]>(`${this.baseUrl}/availableassemblies/${fid}/${planId}/${ssid}`);
  }

  getFoundersCatalog(fid: number,planId: number): Observable<Assembly[]> {
    return this.http.get<Assembly[]>(`${this.baseUrl}/foundersassemblies/${fid}/${planId}`);
  }

  getFullCatalog(fid: number): Observable<Assembly[]> {
    return this.http.get<Assembly[]>(`${this.baseUrl}/fullcatalog/${fid}`);
  }

  saveAssembly(payload: AssemblySaveRequest): Observable<Assembly> {
    return this.http.post<Assembly>(`${this.baseUrl}/saveassembly`, payload);
  }

  saveAssemblyToTemplate(assembly: AssemblySaveRequest,SSID: number): Observable<Assembly> {
    return this.http.post<Assembly>(`${this.baseUrl}/saveassemblytotemplate/${SSID}`, assembly);
  }

}
